//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, TagType } from './Enums';

export class TagInputItem extends ItemBase {
    GroupName?: string | null;     // OBSOLETE - Use only for compatibility
    Name: string | null = null;
    Description: string | null = null;
    StudentIDs: string[] = [];
    TeacherIDs: string[] = [];
    Color: EventColorEnum = EventColorEnum.Gray;
    Type: TagType = TagType.Group;

    constructor(initializer?: Partial<TagInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TagInputItem";
}
